class ComponentSubCollections extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.updateSliderState()
    const DEBOUNCE_DELAY = 150
    this._onResize = this.debounce(this.updateSliderState.bind(this), DEBOUNCE_DELAY)
    window.addEventListener('resize', this._onResize)
  }

  disconnectedCallback() {
    if (this._onResize) {
      window.removeEventListener('resize', this._onResize)
      this._onResize = null
    }
    this.destroySlider()
  }

  initSlider() {
    const $slider = $(this).find('.js-slider')
    if (!$slider || !$slider.length) return
    if ($slider.hasClass('slick-initialized')) return
    const arrowSvg = `
      <svg width="21" height="10" viewBox="0 0 21 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.3188 4.13043L0 4.13043L0 6.01449L17.1739 6.01449L14.4928 8.69565L15.8696 10L20.942 5.07246L15.8696 2.59994e-07L14.4928 1.30435L17.3188 4.13043Z" fill="#4F1F00"/>
      </svg>
    `
    $slider.slick({
      variableWidth: true,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      prevArrow: `<button type="button" class="slick-prev" aria-label="Previous">${arrowSvg}</button>`,
      nextArrow: `<button type="button" class="slick-next" aria-label="Next">${arrowSvg}</button>`,
    })

    const updateArrowDisabled = () => {
      const $list = $slider.find('.slick-list')
      const $track = $slider.find('.slick-track')
      if (!$list.length || !$track.length) return
      const $allSlides = $track.children('.slick-slide').not('.slick-cloned')
      if (!$allSlides.length) return
      const firstEl = $allSlides.first()[0]
      const lastEl = $allSlides.last()[0]
      if (!firstEl || !lastEl) return

      const listRect = $list[0].getBoundingClientRect()
      const firstRect = firstEl.getBoundingClientRect()
      const lastRect = lastEl.getBoundingClientRect()

      const epsilon = 1
      const atStart = Math.round(firstRect.left) >= Math.round(listRect.left - epsilon)
      const atEnd = Math.round(lastRect.right) <= Math.round(listRect.right + epsilon)

      $slider.find('.slick-prev').attr('aria-disabled', atStart ? 'true' : 'false')
      $slider.find('.slick-next').attr('aria-disabled', atEnd ? 'true' : 'false')
    }

    $slider.off('.subcollections')
    $slider.on('init.subcollections reInit.subcollections afterChange.subcollections setPosition.subcollections', updateArrowDisabled)

    updateArrowDisabled()
  }

  destroySlider() {
    const $slider = $(this).find('.js-slider')
    if (!$slider || !$slider.length) return
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick')
    }
  }

  updateSliderState() {
    const $slider = $(this).find('.js-slider')
    if (!$slider || !$slider.length) return
    const el = $slider[0]
    const isOverflowing = el.scrollWidth > el.clientWidth
    if (isOverflowing) {
      this.initSlider()
    } else {
      this.destroySlider()
    }
  }

  debounce(fn, wait) {
    let timeoutId
    return (...args) => {
      clearTimeout(timeoutId)
      timeoutId = setTimeout(() => fn.apply(this, args), wait)
    }
  }
}

customElements.define('sub-collections', ComponentSubCollections)
